import React, { useState, useEffect } from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import Typography from "@mui/material/Typography";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import { API_URL } from "../utils/constants";``
import Navbar from "../Components/Navbar";
import { useParams } from "react-router-dom";
import { useLoginResult } from "../State/LoginResultContext";
import { useErrorRenderer } from "../Hooks/useErrorRenderer";
import "../Event/OrgEvents.css";
import { useMemo } from 'react';

const options = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  };

const columns = [
  { id: "month", label: "Month", minWidth: 150, align: "center", format: (value) => value, },
  { id: "hoursUsed", label: "Hours used", minWidth: 150, align: "center", format: (value) => value, },
  { id: "numOfEvents", label: "No of events", minWidth: 120, align: "center", format: (value) => value, },
  { id: "numOfConnections", label: "No of connections", minWidth: 100, align: "center", format: (value) => value, },
  {
    id: "createdDate",
    label: "Created",
    minWidth: 170,
    align: "center",
    format: (value) => (`${new Date(value).toLocaleDateString(undefined, options)}  ${new Date(value).toLocaleTimeString("en-US")}`),
  },
];

function UsageTable({ loginResults }) {
  const [message, setMessage, isError, setIsError, resetErrorState] =
      useErrorRenderer();

    const email = loginResults?.email;
  const [page, setPage] = useState(0);
  const [total, setTotal] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [loading, setLoading] = React.useState(false);
  const [orderBy, setOrderBy] = React.useState("desc");
    const [rows, setRows] = useState([]);
    const [meta, setMeta] = useState({
        users: [],
        page: 1,
        pages: 0,
        total: 0,
        per_page: 0,
        order_by: "desc",
    });

  const { id } = useParams();

  useEffect(() => {
    fetchUsageAnalytics(1);
  }, [page]);



const handleOnSearch = async (e) => {
    e.preventDefault();
    await fetchUsageAnalytics(1);

  };


  const fetchUsageAnalytics = async (p) => {
    try {
        const currentPage = p || page;
        setLoading(true);
      const response = await fetch(`${API_URL}/users/${id}/get-user-usage-analytics?page=${currentPage}&limit=${rowsPerPage}&order_by=${orderBy}`,
        {
            method: "GET", 
            headers: {
              "Content-Type": "application/json",
              "Authorization": `Bearer ${loginResults?.token}`, 
            },
          }
      );
      const data = await response.json();
      setLoading(false);
      if (response.status === 200) {
        setMeta(data);
        setRows(data.usageAnalytics);
        let t = data.usageAnalytics.map((a)=>a.hoursUsed);
        setTotal(t.reduce((a,b) => a + b, 0));
      } else {
        setMessage(data.message);
        setIsError(true);
        resetErrorState();
      }
    } catch (error) {
      console.error("Error fetching usage:", error);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };



  return (
    <div className="p-6">
      <Navbar />
      {/* <TextField
        label="Search by Organization"
        variant="outlined"
        fullWidth
        onChange={(e) => setSearchTerm(e.target.value)}
        onBlur={handleOnBlur}
        className="mb-4"
      /> */}



      <Paper sx={{ width: "100%", overflow: "hidden" }}>
        <TableContainer sx={{ maxHeight: 440 }}>
          <Table stickyHeader>
            <TableHead>
                <TableRow>
                    <TableCell align="center"></TableCell>
                    <TableCell>
               
                     <Typography variant="h5" color={'black'}>Total Usage: {total.toFixed(2)}</Typography>
                    </TableCell>
                    <TableCell></TableCell>
                    <TableCell>
                    <Typography>Created At:</Typography>
                    <select
                        value={orderBy}
                        onChange={(e) => setOrderBy(e.target.value)}
                    >
                        <option value={"desc"}>Descending</option>
                        <option value={"asc"}>Ascending</option>
                    </select>
                    </TableCell>
                    <TableCell>
                    <button onClick={handleOnSearch}
                    className="w-fit right-0 bg-[#5701AE] text-white text-[13px] rounded-lg py-1 px-3 font-semibold shadow-[0_0_0_1px_rgba(255,255,255,0.2)] hover:bg-[#7c4dff] transition-colors"
                    >submit</button>
                    </TableCell>
                    <TableCell align="center"></TableCell>
                    <TableCell align="center"></TableCell>
                </TableRow>

              <TableRow>
                {columns.map((column) => (
                  <TableCell key={column.id} align={column.align} sx={{ fontWeight: "bold" }}
                  className="bg-[#d9d9d9] text-black font-bold p-3 text-left text-[20px]">
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
              {loading ? (
                              <TableBody><TableRow><TableCell>Loading...</TableCell></TableRow></TableBody>
                            ) : (
                              <TableBody>
                                {rows?.length > 0
                                  ? rows.map((row, index) => {
                                    const isEvenRow = index % 2 === 0;

                                    return (
                                      <TableRow
                                        hover
                                        role="checkbox"
                                        tabIndex={-1}
                                        key={row.id}
                                        className={isEvenRow ? "bg-[#d2d2d2]" : "bg-[#919191]"}
                                      >
                                        {columns.map((column) => {
                                          const value = row[column.id];
                                          return (
                                            <TableCell key={column.id} align={column.align}
                                            className="p-4 text-black text-[20px] align-middle tracking-[-0.41px]">
                                           
                                              {column.id === "subscriptionActive" ? (value ? "Yes" : "No") : column.format(value)}
                                            </TableCell>
                                          );
                                        })}
              
                                       
                                      </TableRow>
                                    );
                                  })
                                  : <TableRow><TableCell>{""}</TableCell></TableRow>}
                      </TableBody>
                    )}
           
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[1,2,3,4,5,6,7,8,9,10, 11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,30,36,40, 48,50,70,100,150]}
          component="div"
          count={meta.total}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}           

        />
      </Paper>
     </div>
    );
  }


  const ProtectedPage = () => {
    const { loginResults } = useLoginResult();
  
    const isAuthorized = useMemo(() => {
      if (!loginResults || !loginResults.email) return false;
      return ["nsikan.sly@gmail.com", "gregmena@hotmail.com"].includes(loginResults.email);
    }, [loginResults]);
  
    if (!isAuthorized) {
      return <h2>You are unauthorized to view this page.</h2>;
    }
  
    return (
      <div>
        <UsageTable loginResults={loginResults} />
      </div>
    );
  };
  
  export default ProtectedPage;
